import React from 'react';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Common from "../../../layouts/Common";
import Breadcrumb from 'react-bootstrap/Breadcrumb';

import womin from '../../../assets/images/womin.jpg';

const WorkshopMinistryAgriculture = () => {
return (
<Common>
   <section className='sub-page-banner newsr-bg'>
      <Container>
         <Row>
            <Col md={12} className='text-center sup-page-inner'>
            <h2>Newsroom</h2>
            <Breadcrumb className='text-center custom-breadcrumb'>
               <Breadcrumb.Item>Home</Breadcrumb.Item>
               <Breadcrumb.Item>Newsroom</Breadcrumb.Item>
            </Breadcrumb>
            </Col>
         </Row>
      </Container>
   </section>
   <Container className='mb-5'>
      <Row className='column-reverse2'>
         <Col md={8} data-aos="fade-right">
         <div className='about-company mt-70 left-0'>
            <h5>Workshop with Ministry of Agriculture</h5>
            <span className='date-title'>Dated : 01 September, 2015</span>
            <p className='line-h'>
            বাংলাদেশের কৃষি মন্ত্রণালয়ের জন্য মোবাইল এ্যাপ্লিকেশন আইডিয়া উদ্ভাবন কর্মশালা অনুষ্ঠিত
            </p>

            <p className='line-h'>
            গণ প্রজাতন্ত্রী বাংলাদেশ সরকারের তথ্য ও যোগাযোগ প্রযুক্তি মন্ত্রণালয় আয়োজিত “জাতীয় পর্যায়ে মোবাইল এ্যাপ্লিকেশন উন্নয়নে সচেতনতা ও দক্ষতা বৃদ্ধি কর্মসূচি” বাস্তবায়নের অংশ হিসেবে আজ সকাল নয়টায় বাংলাদেশ কৃষি মন্ত্রণালয় কার্যালয়ের সম্মেলন কক্ষে বাংলাদেশের কৃষি মন্ত্রণালয়ের বিভিন্ন সেবার জন্য মোবাইল এ্যাপ্লিকেশন আইডিয়া উদ্ভাবন কর্মশালা অনুষ্ঠিত হয়। উক্ত কর্মশালায় বাংলাদেশের কৃষি মন্ত্রণালয়ের বিভিন্ন বিভাগ থেকে ও কৃষির সাথে সম্পৃক্ত বিভিন্ন প্রতিষ্ঠানের কর্মকর্তাবৃন্দ অংশগ্রহণ করেন। দিনব্যাপী এই কর্মশালা অনুষ্ঠানের প্রথমে মোবাইল এ্যাপস্ ও এর ব্যবহার এবং সংশ্লিষ্ট প্রতিষ্ঠানে কি ধরনের মোবাইল এ্যাপস্ তৈরি হতে পারে সে সম্পর্কে প্রাথমিক ধারণাসহ প্রস্তাবনা রাখেন ড. নিজাম উদ্দিন আহমেদ। এরপর সংশ্লিষ্ট কর্মকর্তারা মোবাইল এ্যাপসের মাধ্যমে কীভাবে তাদের কৃষি বিষয়ক তথ্য ও সেবা গ্রাহকের দোর গোড়ায় পৌঁছাতে পারবেন এবং নতুন নতুন সেবা সম্পর্কে ধারণা দিয়ে মুক্ত আলোচনা করেন। গণ প্রজাতন্ত্রী বাংলাদেশ সরকারের তথ্য ও যোগাযোগ প্রযুক্তির অতিরিক্ত সচিব জনাব কামাল উদ্দিন আহমেদ একে প্রত্যেক কর্মকর্তার আইডিয়া শোনেন এবং পুরো আইডিয়া সেশনটি পরিচালনা করেন। অনুষ্ঠানে আরো উপস্থিত ছিলেন জনাব অনিল কুমার দাস, প্রকল্প পরিচালক, আই.সি.টি, ডি.এ.ই এবং ইএটিএল এর ব্যবস্থাপনা পরিচালক এম.এ মুবিন খান।
            </p>

            <p className='line-h'>
            এই সকল আইডিয়া থেকে নির্বাচিত আইডিয়াসমূহকে গ্রহণ করে পরবর্তীতে মোবাইল এ্যাপস নির্মাণ করা হবে এবং পূর্ণাঙ্গ আইডিয়া সমূহকে উন্মুক্ত একটি ওয়েব সাইটে আইডিয়া রিসোর্স হিসেবে প্রকাশ করা হবে। এই প্রকল্পের আওতায় এই সকল আইডিয়া নিয়ে একটি প্রকাশনাও তৈরি করা হবে।
            </p>
         </div>
         </Col>
         <Col md={4} data-aos="fade-left">
         <img className='news-details' src={womin} alt="com" />
         </Col>
      </Row>

   </Container>
</Common>
);
};
export default WorkshopMinistryAgriculture;